import React, { createContext, useContext } from 'react';
import { UserTier } from '../pages/DashboardPage/mockData';

interface TierContextType {
  tier: UserTier;
}

const TierContext = createContext<TierContextType | undefined>(undefined);

interface TierProviderProps {
  tier: UserTier;
  children: React.ReactNode;
}

export const TierProvider: React.FC<TierProviderProps> = ({ tier, children }) => {
  return (
    <TierContext.Provider value={{ tier }}>
      {children}
    </TierContext.Provider>
  );
};

export const useTier = () => {
  const context = useContext(TierContext);
  if (context === undefined) {
    throw new Error('useTier must be used within a TierProvider');
  }
  return context;
};
